import { transliterate } from "transliteration";

import extractDomainFromString from "./extractDomainFromString";

const unicodeTld = (fullDomain) => {
  const { domain, tld } = extractDomainFromString(fullDomain);

  if (!domain || !tld) {
    return fullDomain;
  }

  const unicodedTld = transliterate(tld);

  return `${domain}${unicodedTld}`;
};

export default unicodeTld;
